import TrainingPlatformPage from '@/components/TrainingPlatformPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: 'Build Cybersecurity Training Programs with Hands-on Labs | SimulationsLabs' },
    {
      name: 'description',
      content:
        'Create and deliver hands-on cybersecurity training programs with real-world labs, simulations, and gamified learning. Build courses, track trainee progress, and access a ready-made scenario library with SimulationsLabs.',
    },
  ];
}

export default function TrainingPlatform() {
  return <TrainingPlatformPage />;
}
